/* eslint-disable */
import { Tooltip } from '@mui/material';
import styles from './gaugeChart.module.scss';
import React from 'react';
import { formatValue } from './utils';
import PropTypes from 'prop-types';

const GaugeChart = ({ data, visible, alignment }) => {
  const { header, type1, type2, type3, val1, val2, val3, other } = data || {};
  const total = val1 + val2 + val3 + (other?.value || 0);
  const percentVal1 = total > 0 ? (val1 / total) * 100 : 0;
  const percentVal2 = total > 0 ? (val2 / total) * 100 : 0;
  const percentVal3 = total > 0 ? (val3 / total) * 100 : 0;
  const percentOther = total > 0 ? ((other?.value || 0) / total) * 100 : 0;
  const positionRef = React.useRef({ x: 0, y: 0 });
  const popperRef = React.useRef(null);
  const areaRef1 = React.useRef(null);
  const areaRef2 = React.useRef(null);
  const areaRef3 = React.useRef(null);
  const areaRefOther = React.useRef(null);

  const handleMouseMove = (event, ref) => {
    positionRef.current = { x: event.clientX, y: event.clientY };
    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>{header}</div>
      <div className={styles['bar-container']}>
      {type1 && val1 !== undefined && (
        <Tooltip
          title={
            <div>
              Value: {formatValue(val1, alignment)} ({percentVal1.toFixed(2)}%)
            </div>
          }
          placement="top"
          arrow
          PopperProps={{
            popperRef,
            anchorEl: {
              getBoundingClientRect: () => {
                if (areaRef1.current) {
                  return new DOMRect(
                    positionRef.current.x,
                    areaRef1.current.getBoundingClientRect().y,
                    0,
                    0
                  );
                }
                return new DOMRect(0, 0, 0, 0);
              },
            },
          }}
          componentsProps={{
            tooltip: {
              className: styles['tooltip'],
            },
            arrow: {
              className: styles['arrow'],
            },
          }}
        >
          <button
            className={`${styles['bar']} ${styles['bar-1']}`}
            style={{ width: `${percentVal1}%`, border:'none', }}
            ref={areaRef1}
            onMouseMove={(e) => handleMouseMove(e, areaRef1)}
          />
        </Tooltip>
      )}
    {type2 && val2 !== undefined && (
        <Tooltip
          title={
            <div>
              Value: {formatValue(val2, alignment)} ({percentVal2.toFixed(2)}%)
            </div>
          }
          placement="top"
          arrow
          PopperProps={{
            popperRef,
            anchorEl: {
              getBoundingClientRect: () => {
                if (areaRef2.current) {
                  return new DOMRect(
                    positionRef.current.x,
                    areaRef2.current.getBoundingClientRect().y,
                    0,
                    0
                  );
                }
                return new DOMRect(0, 0, 0, 0);
              },
            },
          }}
          componentsProps={{
            tooltip: {
              className: styles['tooltip'],
            },
            arrow: {
              className: styles['arrow'],
            },
          }}
        >
          <button
            className={`${styles['bar']} ${styles['bar-2']}`}
            style={{ width: `${percentVal2}%`, border:'none' }}
            ref={areaRef2}
            onMouseMove={(e) => handleMouseMove(e, areaRef2)}
          />
        </Tooltip>
        )}
    {type3 && val3 !== undefined && (
        <Tooltip
          title={
            <div>
              Value: {formatValue(val3, alignment)} ({percentVal3.toFixed(2)}%)
            </div>
          }
          placement="top"
          arrow
          PopperProps={{
            popperRef,
            anchorEl: {
              getBoundingClientRect: () => {
                if (areaRef3.current) {
                  return new DOMRect(
                    positionRef.current.x,
                    areaRef3.current.getBoundingClientRect().y,
                    0,
                    0
                  );
                }
                return new DOMRect(0, 0, 0, 0);
              },
            },
          }}
          componentsProps={{
            tooltip: {
              className: styles['tooltip'],
            },
            arrow: {
              className: styles['arrow'],
            },
          }}
        >
          <button
            className={`${styles['bar']} ${styles['bar-3']}`}
            style={{ width: `${percentVal3}%`, border:'none' }}
            ref={areaRef3}
            onMouseMove={(e) => handleMouseMove(e, areaRef3)}
          />
        </Tooltip>
      )}
        {other && other.value !== undefined && (
          <Tooltip
            title={
              <div>
                Value: {formatValue(other.value, alignment)} (
                {percentOther.toFixed(2)}%)
              </div>
            }
            placement="top"
            arrow
            PopperProps={{
              popperRef,
              anchorEl: {
                getBoundingClientRect: () => {
                  if (areaRefOther.current) {
                    return new DOMRect(
                      positionRef.current.x,
                      areaRefOther.current.getBoundingClientRect().y,
                      0,
                      0
                    );
                  }
                  return new DOMRect(0, 0, 0, 0);
                },
              },
            }}
            componentsProps={{
              tooltip: { className: styles['tooltip'] },
              arrow: { className: styles['arrow'] },
            }}
          >
            <button
              className={`${styles['bar']} ${styles['bar-other']}`}
              style={{ width: `${percentOther}%`, border: 'none' }}
              ref={areaRefOther}
              onMouseMove={(e) => handleMouseMove(e, areaRefOther)}
            />
          </Tooltip>
        )}
      </div>
      <div className={styles['legend-container']}>
    {type1 && (
        <div className={styles['legend-item']}>
          <div className={styles['legend-box']}>
            <div className={`${styles['color-box']} ${styles['bar-1']}`} />
            <div>
              <div className={styles['label']}>{type1}</div>
            </div>
          </div>
          <div>
            <div
              className={`${styles['value']} ${
                visible ? styles['fade-in'] : styles['fade-out']
              }`}
            >
              {alignment === 'Value' ? '$' : ''}
              {formatValue(val1, alignment)}
            </div>
          </div>
        </div>
      )}
        {type2 && (
          <div className={styles['legend-item']}>
            <div className={styles['legend-box']}>
            <div className={`${styles['color-box']} ${styles['bar-2']}`} />
            <div>
              <div className={styles['label']}>{type2}</div>
            </div>
          </div>
          <div>
            <div
              className={`${styles['value']} ${
                visible ? styles['fade-in'] : styles['fade-out']
              }`}
            >
              {alignment === 'Value' ? '$' : ''}
              {formatValue(val2, alignment)}
            </div>
          </div>
        </div>
      )}
        {type3 && (
        <div className={styles['legend-item']}>
          <div className={styles['legend-box']}>
            <div className={`${styles['color-box']} ${styles['bar-3']}`} />
            <div>
              <div className={styles['label']}>{type3}</div>
            </div>
          </div>
          <div>
            <div
              className={`${styles['value']} ${
                visible ? styles['fade-in'] : styles['fade-out']
              }`}
            >
              {alignment === 'Value' ? '$' : ''}
              {formatValue(val3, alignment)}
            </div>
          </div>
        </div>
      )}
        {other && (
          <div className={styles['legend-item']}>
            <div className={styles['legend-box']}>
              <div className={`${styles['color-box']} ${styles['bar-other']}`} />
              <div>
                <div className={styles['label']}>{other.label}</div>
              </div>
            </div>
            <div>
              <div
                className={`${styles['value']} ${
                  visible ? styles['fade-in'] : styles['fade-out']
                }`}
              >
                {alignment === 'Value' ? '$' : ''}
                {formatValue(other.value, alignment)}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

GaugeChart.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.string,
    type1: PropTypes.string,
    type2: PropTypes.string,
    type3: PropTypes.string,
    val1: PropTypes.number,
    val2: PropTypes.number,
    val3: PropTypes.number,
    other: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    }),
  }).isRequired,
  visible: PropTypes.bool.isRequired,
  alignment: PropTypes.string.isRequired,
};

export default GaugeChart;
